import * as angular from 'angular';
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class AccountProvidersTableComponent implements IController {
  threePlProviderData: Object;
  onRemove: Function;
  onEdit: Function;

  public providers: string[];

  /* @ngInject */
  constructor(private splitService: SplitService) {
    this.providers = this.splitService.getSupportedThreePlProviders();
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountProvidersTable', {
    bindings: {
      threePlProviderData: '<',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./account-providers-table.html').default,
    controller: AccountProvidersTableComponent
  });
